

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">

    <div class="information-margin"></div>

    <!-- メッセージ -->
    <div class="message">
      <!-- メッセージ本文 -->
      <div class="message-text">
        <div class="p-d-flex p-jc-center">
          <i class="pi pi-check-circle black-color"></i><br />
        </div>
        <div class="message-margin"></div>
        <div class="p-d-flex p-jc-center black-color">{{title}}</div>
      </div>
    </div>
    <!-- ボタンエリア -->
    <div class="p-d-flex p-jc-center button-area">
      <button
        pButton
        type="button"
        [label]="roleAuth!='9'?'マイページへ戻る':'トップページへ戻る'"
        class="button-default-size"
        (click)="moveB301()"
      ></button>
    </div>
  </div>
</div>
